import AthubCloudApi from '@/api/athubCloud';
import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';

export const DICTIONARY_FACTORY_DEPARTMENT = 'department';
export const DICTIONARY_FACTORY_DEPARTMENT_TYPE_AUTH_SITE = 'AUTH_SITE';
export const DICTIONARY_FACTORY_DEPARTMENT_TYPE_RUNNING = 'RUNNING';
export const DICTIONARY_FACTORY_DEPARTMENT_TYPE_JOB_PLAN = 'JOB_PLAN';
export default class DepartmentDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_DEPARTMENT});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_DEPARTMENT_TYPE_AUTH_SITE: {
                let departments = await AthubCloudApi.fetchDeptListByAuthSites();
                dictionary = new Dictionary({items: departments, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_DEPARTMENT_TYPE_RUNNING: {
                let departments = await AthubCloudApi.fetchRunningDeptList();
                dictionary = new Dictionary({items: departments, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_DEPARTMENT_TYPE_JOB_PLAN: {
                let departments = await AthubCloudApi.getDept4JobPlan();
                dictionary = new Dictionary({items: departments, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}